export default __webpack_public_path__ + "static/NeedsSection_it-b75c64503da0a8057f76a1dc2d2451e5.png";